import React, { useState, useEffect } from 'react';
import { Modal, Button, Form, Card, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import { var_api } from '../../../constant';
import axios from 'axios';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";  

const ExpenseMaster = () => {
  const tableHeaders = ["#", " Expense Name", "Description", "Status", "Action"];
  const [expenseData, setExpenseData] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [formData, setFormData] = useState({
    id: null,
    expense_name: '',
    description: '',
    active_status: 1,
    warehouse_id: localStorage.getItem('warehouse_id')
  });
  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 15;
  const [initialLoading, setInitialLoading] = useState(true);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();  

  useEffect(() => {
    loadInitialData();
  }, []);

  const loadInitialData = async () => {
    try {
      setInitialLoading(true);
      await fetchExpenseData();
    } catch (error) {
      toast.error("Error loading data");
    } finally {
      setInitialLoading(false);
    }
  };

  const fetchExpenseData = async () => {
    const warehouse_id = localStorage.getItem("warehouse_id");
    try {
      const res = await axios.get(`${var_api}sa_veemart_expensename_master/getbywarehouse/${warehouse_id}`);
      setExpenseData(res.data || []);
    } catch {
      toast.error("Failed to fetch expense data");
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value,
    }));
    setErrors(prev => ({
      ...prev,
      [name]: '',
    }));
  };

  const handleAddClick = () => {
    setFormData({ id: null, expense_name: '', description: '', active_status: 1, warehouse_id: localStorage.getItem('warehouse_id') });
    setIsEditMode(false);
    setErrors({});
    setShowModal(true);
  };

  const handleEditClick = (item) => {
    setFormData({ ...item });
    setIsEditMode(true);
    setErrors({});
    setShowModal(true);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const newErrors = {};
    if (!formData.expense_name.trim()) newErrors.expense_name = "Expense name is required";
    setErrors(newErrors);

    if (Object.keys(newErrors).length > 0) {
      toast.warning("Please correct the highlighted fields");
      return;
    }

    try {
      setLoading(true);
      let res;
      if (isEditMode && formData.id) {
        res = await axios.put(`${var_api}sa_veemart_expensename_master/update/${formData.id}`, formData);
      } else {
        res = await axios.post(`${var_api}sa_veemart_expensename_master/post`, formData);
      }

      toast.success(res?.data?.message || "Expense saved successfully!");
      setShowModal(false);
      setFormData({ id: null, expense_name: '', description: '', active_status: 1 });
      fetchExpenseData();
    } catch (err) {
      toast.error(err?.response?.data?.message || "Failed to save expense");
    } finally {
      setLoading(false);
    }
  };

  const filteredData = expenseData.filter(item =>
    Object.values(item).some(val => String(val).toLowerCase().includes(searchQuery.toLowerCase()))
  );

  const totalPages = Math.ceil(filteredData.length / itemsPerPage);
  const paginatedData = filteredData.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);

  return (
    <>
      <Card>
        <Card.Body>
              <div>
  <h5 className="mb-0">
    <i className="fas fa-credit-card"></i> Expense Name Master
  </h5>
 
</div>
          {initialLoading ? (
            <div className="text-center my-5">
              <div className="spinner-border text-primary" role="status"></div>
              <div>Loading data...</div>
            </div>
          ) : (
            <>
              <div className="d-flex justify-content-end mb-3 gap-2">
                       
                <input
                  type="text"
                  className="form-control w-auto"
                  placeholder="Search expense..."
                  value={searchQuery}
                  onChange={e => {
                    setSearchQuery(e.target.value);
                    setCurrentPage(1);
                  }}
                />
                <Button variant="secondary" onClick={handleAddClick}>Add</Button>
              </div>

              <div className="table-responsive">
                <table className="table">
                  <thead>
                    <tr>{tableHeaders.map((header, idx) => (<th key={idx}>{header}</th>))}</tr>
                  </thead>
                  <tbody>
                    {paginatedData.length === 0 ? (
                      <tr>
                        <td colSpan="6" className="text-center text-muted py-3">
                          No data found
                        </td>
                      </tr>
                    ) : (
                      paginatedData.map((item, idx) => (
                        <tr key={item.id}>
                          <td>{(currentPage - 1) * itemsPerPage + idx + 1}</td>
                          <td>{item.expense_name}</td>
                          <td>{item.description}</td>
                          <td>
                            <span className={`badge ${item.active_status === 1 || item.active_status === 'Active' ? 'bg-success' : 'bg-danger'}`}>
                              {item.active_status === 1 || item.active_status === 'Active' ? 'Active' : 'Inactive'}
                            </span>
                          </td>
                          <td >
                            <Link
                              to="#"
                              className="btn shadow btn-xs sharp me-1"
                              style={{ backgroundColor: "#007bff", color: "white" }}
                              onClick={() => handleEditClick(item)}
                            >
                              <i className="fas fa-pencil-alt"></i>
                            </Link>
                       
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
                <div className="d-flex justify-content-end mt-3">
                  {[...Array(totalPages)].map((_, idx) => (
                    <Button
                      key={idx}
                      variant={currentPage === idx + 1 ? "primary" : "light"}
                      onClick={() => setCurrentPage(idx + 1)}
                      className="me-1"
                    >
                      {idx + 1}
                    </Button>
                  ))}
                </div>
              </div>
            </>
          )}
        </Card.Body>

        {/* Modal Form */}
        <Modal show={showModal} onHide={() => setShowModal(false)} size="lg" centered>
          <Modal.Header closeButton>
            <Modal.Title>{isEditMode ? "Edit Expense" : "Add Expense"}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form onSubmit={handleSubmit}>
              <Row>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Expense Name <span className="text-danger">*</span></Form.Label>
                    <Form.Control
                      type="text"
                      name="expense_name"
                      value={formData.expense_name}
                      placeholder="Enter expense name"
                      onChange={handleInputChange}
                    />
                    {errors.expense_name && <div className="text-danger small mt-1">{errors.expense_name}</div>}
                  </Form.Group>
                </Col>

                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Description</Form.Label>
                    <Form.Control
                      type="text"
                      name="description"
                      value={formData.description}
                      placeholder="Enter description"
                      onChange={handleInputChange}
                    />
                  </Form.Group>
                </Col>

                {isEditMode && (
                  <Col md={6}>
                    <Form.Group className="mb-2 d-flex align-items-center gap-2">
                      <Form.Label className="mb-0">
                        {formData.active_status === 1 || formData.active_status === 'Active' ? "Active" : "Inactive"}
                      </Form.Label>
                      <Form.Check
                        type="switch"
                        id="active-status-switch"
                        checked={formData.active_status === 1 || formData.active_status === 'Active'}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            active_status: e.target.checked ? 1 : 0,
                          })
                        }
                        className={
                          formData.active_status === 1 || formData.active_status === 'Active'
                            ? "custom-switch-green"
                            : ""
                        }
                      />
                    </Form.Group>
                  </Col>
                )}
              </Row>

              <div className="d-flex justify-content-end gap-2">
                {!isEditMode ? (
                  <>
                    <Button variant="secondary" type="submit" disabled={loading}>
                      {loading ? (
                        <>
                          <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                          Creating...
                        </>
                      ) : (
                        "Create"
                      )}
                    </Button>
                    <Button
                      variant="danger"
                      type="reset"
                      disabled={loading}
                      onClick={() =>
                        setFormData({
                          id: null,
                          expense_name: '',
                          description: '',
                          active_status: 1,
                          warehouse_id: localStorage.getItem('warehouse_id')
                        })
                      }
                    >
                      Reset
                    </Button>
                  </>
                ) : (
                  <>
                    <Button variant="warning" type="submit" disabled={loading}>
                      {loading ? (
                        <>
                          <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                          Updating...
                        </>
                      ) : (
                        "Update"
                      )}
                    </Button>
                    <Button variant="danger" onClick={() => setShowModal(false)} disabled={loading}>
                      Cancel
                    </Button>
                  </>
                )}
              </div>
            </Form>
          </Modal.Body>
        </Modal>

        <style>{`
          .custom-switch-green .form-check-input:checked {
            background-color: #28a745 !important;
            border-color: #28a745 !important;
          }
        `}</style>
      </Card>

      <ToastContainer />
    </>
  );
};

export default ExpenseMaster; 